<template>
  <div class="contact-us-container">
    <div class="contact-us-wrapper">
      <div class="form-section">
        <header class="title-container">
          <span class="title-decorator"></span>
          <h1 class="title">Contact Us</h1>
        </header>
        <p class="subtitle">
          If you would like to receive a quote or learn more about our products,
          <br />
          please leave us a message.
        </p>
        <el-form ref="form" :model="formInfo" label-width="80px">
          <div class="form-row">
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-select
                  v-model="formInfo.productInterest"
                  popper-class="contact-us-select-proj"
                  :popper-append-to-body="false"
                  placeholder=" Which product are you interested in?"
                >
                  <el-option
                    :label="item.name"
                    :value="item.id"
                    v-for="item in productOptions"
                    :key="item.id"
                  ></el-option>
                </el-select>
              </el-form-item>
            </div>
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.name"
                  placeholder="Your Name"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.email"
                  placeholder="Your Email"
                ></el-input>
              </el-form-item>
            </div>
            <div class="form-group half-width">
              <el-form-item label="" label-width="0px">
                <ContactInfo
                  :areacode.sync="formInfo.ac"
                  :phone.sync="formInfo.phone"
                  language="en"
                ></ContactInfo>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  v-model="formInfo.companyInstitutionInfo"
                  placeholder="Your company or institution information"
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <div class="form-group full-width">
              <el-form-item label="" label-width="0px">
                <el-input
                  type="textarea"
                  rows="4"
                  v-model="formInfo.requirements"
                  placeholder="You can leave your requirements, and we will develop a tailored solution and get in touch with you."
                ></el-input>
              </el-form-item>
            </div>
          </div>
          <div class="form-row">
            <button
              class="submit-button"
              :class="{ disabled: !isValid }"
              @click="handlerSubmit"
            >
              Submit
            </button>
          </div>
        </el-form>
      </div>
      <div class="info-section">
        <h2>Contact Information Business Inquiry:</h2>
        <p class="info-sec-item strong">Mr. Yipin Zhang</p>
        <p class="info-sec-item">Phone: +65 93524366</p>
        <p class="info-sec-item">WhatsApp: +65 93524366</p>
        <p class="info-sec-item">Email: zhangyipin@jsdnn.com</p>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import ContactInfo from "./ContactInfo.vue";
import { productListApi, saveConsultInfoApi } from "@/api/website";
export default {
  components: { ContactInfo },
  name: "ContractUs",
  data() {
    return {
      productOptions: [
        // { value: "1", text: "Digital Design Software Product Line" },
        // { value: "2", text: "Intelligent Construction Product Line" },
        // { value: "3", text: "O&M Digital Twin Solutions" },
        // { value: "4", text: "AIRoad" },
        // { value: "5", text: "EICAD" },
        // { value: "6", text: "VRRoad" },
      ],
      formInfo: {
        productInterest: "",
        name: "",
        email: "",
        ac: "+65",
        phone: "",
        requirements: "",
        companyInstitutionInfo: "",
      },
    };
  },
  computed: {
    isValid() {
      return (
        this.formInfo.name &&
        this.formInfo.email &&
        this.formInfo.phone &&
        this.formInfo.productInterest &&
        this.formInfo.companyInstitutionInfo
      );
    },
  },
  mounted() {
    this.getProductList();
  },
  methods: {
    resertForm() {
      this.formInfo = {
        name: "",
        email: "",
        productInterest: "",
        message: "",
        phone: "",
        ac: "+65",
        companyInstitutionInfo: "",
      };
    },

    getProductList() {
      productListApi().then((res) => {
        if (res.code == 200 && res.success) this.productOptions = res.data;
      });
    },
    handlerSubmit(e) {
      // console.log("handlerSubmit------", this.formInfo);
      e.preventDefault();
      if (this.isValid) {
        // 校验邮箱格式
        const emailPattern = /^[\w.-]+@[\w.-]+\.[a-zA-Z]{2,}$/;
        if (!emailPattern.test(this.formInfo.email)) {
          this.$message.error("Please enter the correct email address.");
          return;
        }
        console.log("this.formData:", this.formInfo);
        let product = this.productOptions.find(
          (item) => item.id === this.formInfo.productInterest,
        );
        let param = {
          productId: this.formInfo.productInterest, //产品ID
          productName: product ? product.name : "", //产品名称
          customerName: this.formInfo.name, //客户姓名
          ac: this.formInfo.ac, //电话地区号
          phone: this.formInfo.phone, //手机号
          email: this.formInfo.email, //电子邮箱，比如 example@qq.com
          guestbook: this.formInfo.requirements, //留言
          companyInstitutionInfo: this.formInfo.companyInstitutionInfo, //公司或院校信息
        };
        saveConsultInfoApi(param).then((res) => {
          if (res.code == 200 && res.success) {
            this.$message.success("submit success");
            this.resertForm();
            // console.log(this.formInfo);
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.contact-us-container {
  font-family: Arial, sans-serif;
  padding: 110px 0;
  background-color: #fff;
  .contact-us-wrapper {
    position: relative;
    display: flex;
    max-width: 1200px;
    margin: auto;
  }

  .form-section {
    flex: 1;
    max-width: 824px;
    padding-right: 40px;
  }

  .title-container {
    display: flex;
    align-items: center;
    margin-bottom: 50px;
    height: 56px;

    .title {
      font-size: 56px;
      font-weight: bold;
      color: #1d1d1f;
      margin: 0;
    }
    .title-decorator {
      position: relative;
      left: -70px;
      top: 0px;
      width: 6px;
      height: 120px;
      background-color: #0035fb;
      margin-right: 15px;
    }
  }

  .subtitle {
    margin-bottom: 40px;
    font-size: 18px;
    line-height: 24px;
    font-weight: bold;
    color: #1d1d1f;
  }

  .form-row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  .form-group {
    display: flex;
    flex-direction: column;
  }

  .half-width {
    width: calc(50% - 10px);
  }

  .full-width {
    width: 100%;
  }

  .el-input .el-input__inner,
  input[type="email"],
  select,
  textarea {
    padding: 20px;
    height: 60px;
    line-height: 60px;
    border: none;
    border-radius: 4px;
    font-size: 16px;
    background-color: #f7f7f7;
    color: #1d1d1f;
    box-sizing: border-box;
    font-family: Arial, Helvetica, sans-serif;
  }
  .el-select {
    width: 100%;
  }
  .el-textarea textarea {
    line-height: 24px;
  }
  .el-form-item {
    margin-bottom: 0;
  }

  input::placeholder,
  textarea::placeholder {
    color: #999;
    font-family: Arial, Helvetica, sans-serif;
  }

  select {
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: none;
    background-image: url("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%27http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%27%20width%3D%27292.4%27%20height%3D%27292.4%27%3E%3Cpath%20fill%3D%27%230035FB%27%20d%3D%27M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%27%2F%3E%3C%2Fsvg%3E");
    background-repeat: no-repeat;
    background-position: right 15px center;
    background-size: 12px;
    color: #1d1d1f;
    &:focus-visible {
      border: none;
      outline: none;
    }
  }

  textarea {
    height: 200px;
    resize: vertical;
    &::placeholder {
      font-family: Arial, Helvetica, sans-serif;
    }
  }

  .submit-button {
    width: 100%;
    max-width: 480px;
    padding: 10px;
    background-color: #0035fb;
    color: white;
    border: none;
    border-radius: 2px;
    font-size: 24px;
    cursor: pointer;
    letter-spacing: 1.5px;
    &.disabled {
      background-color: #ddd;
      cursor: not-allowed;
    }
  }

  .submit-button:hover {
    opacity: 0.8;
  }

  // 右侧信息
  .info-section {
    position: relative;
    top: 110px;
    width: 260px;
    h2 {
      margin-bottom: 40px;
      max-width: 250px;
      font-size: 18px;
      font-weight: bold;
      color: #1d1d1f;
      line-height: 24px;
    }

    .info-sec-item {
      font-size: 16px;
      color: #1d1d1f;
      // margin-bottom: 8px;
      letter-spacing: 1px;
      line-height: 24px;
      &.strong {
        font-weight: bold;
      }
    }
  }
  .el-select-dropdown {
    .popper__arrow {
      display: none;
    }
    .el-scrollbar__view {
      padding: 0;
    }
    .el-select-dropdown__item {
      height: 48px;
      line-height: 48px;
      font-weight: 400;
      font-size: 16px;
      color: #1d1d1f;
      text-align: justify;
      font-style: normal;
    }
  }
}
</style>
